

export let TIS10 = {
    //the ports
    Up: null,
    Down: null,
    Left: null,
    Right: null,
    
    Acc: 0, //accumulator
    PC: 0, //program counter
    Bak: 0, //backup register for saves
    Last: 0,  //last used (not implemented)
    SymbolTable: [], //storing label destinations
    Memory: [], //the memory
    Running: false, //is the machine currently running
    Cycles: 0, //#of cycles used 
    AutoLoop: true,
    IOAccess:0, //how many i/o operations
    InstructionCount:0, //size of the program
    MaxCycles:9999,
    
    //if something bad happens and what it was
    ErrorFlag: false,
    ErrorString: "",
    
    //return an error if these ports used
    ErrorPort: "",
    
    //arrows
    UpArrow: "",
    DownArrow:  "",
    LeftArrow: "",
    RightArrow: "",
    
    //basically the setup for the machine and compilation
    //it's pseudo because it doesn't actually turn it into machine code
    PseudoAssemble: function(memory,loopy)
    {
        //should be an array of 16 rows
        this.Memory = memory;
        this.Running = true;
        //ports
        this.Up = null;
        this.Down = null;
        this.Left = null;
        this.Right = null;
        
        //registers
        this.Acc = 0; //accumulator
        this.PC = 0;  //program counter
        this.Bak = 0; //bak register
        this.Last = 0; //last pseudo port not used
        this.Cycles = 1; //number of cycles
        
        this.SymbolTable = [];
        this.GetSymbols();
        this.AutoLoop = loopy;
        this.IOAccess= 0;
        this.InstCount();
        this.MaxCycles = 9999;
         //for(i=0; i < memarr.length; i++)
         //   { this.Memory[i] = memarr[i];}
        
        //error stuff
        this.ErrorFlag = false;
        this.ErrorString = "";
        this.BrokenPort = "";
        
        //Port arrows
        this.UpArrow = "";
        this.DownArrow = "";
        this.LeftArrow = "";
        this.RightArrow = "";
        return;
    },
    
    //use regex to check syntax
    SyntaxCheck: function(script)
    {
        /*
        ^ *(\w+:)* *(SWP|SAV|NEG|NOP|(ADD +(\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL))|(SUB +(\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL))|(JMP\s+\w+)|(JEZ +\w+)|(JLZ +\w+)|(JGZ +\w+)|(JRO +(\d+|\w+))|MOV +(\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL) *, *(UP|DOWN|RIGHT|LEFT|ACC|NIL))? *(#.*)*$
         */
        const regex =/^ *(\w+:)* *(SWP|SAV|NEG|NOP|(ADD +(-?\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL))|(SUB +(-?\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL))|(JMP\s+\w+)|(JEZ +\w+)|(JLZ +\w+)|(JGZ +\w+)|(JRO +(-?\d+|\w+))|MOV +(-?\d+|UP|DOWN|RIGHT|LEFT|ACC|NIL) *, *(UP|DOWN|RIGHT|LEFT|ACC|NIL))? *(#.*)*$/;
        
        var j;
        var pass = true;
        
        //apply regex line by line and fail if bad
        for(j = 0 ; j < script.length; j++)
        {
            var jline = script[j];
            if(regex.test(jline) == false && jline.replace(' ','').length > 0)
                pass = false;
        }
        
        //check all symbols s:
        //we actually just handle the error
         
        return pass;
    },
    
    //build the symbol table
    GetSymbols: function()
    {
        //parse to find symbols
        //could also fake this and just dynamically find it
        let i = 0;
        for(i = 0 ; i < this.Memory.length; i++)
        {
            let line = this.Memory[i];
            //remove comment by throwing away anything after #
            if(line.indexOf('#') >= 0)
            {
                //let indp = line.indexOf('#');
                line = line.substring(0, line.indexOf('#'));
            }
            //get symbol by getting everything before : (check for whitespace?)
            if(line.indexOf(':') >= 0)
            {
                //let indy = line.indexOf(':');
                //let sym = line.substring(0,line.indexOf(':'));
                line = line.substring(0,line.lastIndexOf(':')+1);
                let ls = line.split(':');
                var k=0;
                for(k=0; k < ls.length; k++)
                {
                    if(ls[k].trim().length > 0)
                        this.SymbolTable[ls[k].trim()] = i;
                }
            }
        }
        return;
    },
    
    //if a port or register is used as a value
    GetValue: function(val)
    {
        
        
        
        if(!isNaN(val)) //literal number
        {
            return parseInt(val);
        }
        else
        {
            let temp;
            //alert('gv: '+val);
            //returns current value and then sets port value to null
            switch(val)
            {
            case "NIL":
                return 0;
                break;
            case "ACC":
                temp = this.Acc;
                //this.Acc = null; //stays in acc
                //return tempa;
                break;
            case "UP":
                //check for error port 
                if(this.ErrorPort.search('U')>=0)
                {
                    this.ErrorFlag = true;
                    this.ErrorString = "READ FROM INVALID PORT UP";
                    return 0;
                }
                temp = this.Up;
                this.Up = null;
                this.IOAccess = this.IOAccess + 1;
                this.UpArrow = "IN";
                //return tempu;
                break;
            case "DOWN":
                //check for error port 
                if(this.ErrorPort.search('D')>=0)
                {
                    this.ErrorFlag = true;
                    this.ErrorString = "READ FROM INVALID PORT DOWN";
                    return 0;
                }
                temp = this.Down;
                this.Down = null;
                this.IOAccess = this.IOAccess + 1;
                this.DownArrow = "IN";
                //return tempd;
                break;
            case "LEFT":
                //check for error port 
                if(this.ErrorPort.search('L')>=0)
                {
                    this.ErrorFlag = true;
                    this.ErrorString = "READ FROM INVALID PORT LEFT";
                    return 0;
                }
                temp = this.Left;
                this.Left = null;
                this.IOAccess = this.IOAccess + 1;
                this.LeftArrow = "IN";
                //return templ;
                break;
            case "RIGHT":
                //check for error port 
                if(this.ErrorPort.search('R')>=0)
                {
                    this.ErrorFlag = true;
                    this.ErrorString = "READ FROM INVALID PORT RIGHT";
                    return 0;
                }
                temp = this.Right;
                this.Right = null;
                this.IOAccess = this.IOAccess + 1;
                this.RightArrow = "IN";
                //return tempr;
                break;
            default: //need to handle error
                this.ErrorFlag = true;
                this.ErrorString = "BAD LOCATION";
                return 0;
                break;
            };
            if(temp == null)
            {
                this.ErrorFlag = true;
                this.ErrorString = "NO DATA ON PORT";
                return 0;
            }
            return temp;
        }
        return;
    },
    
    //the machine taking the next computation step (not the same as the cycle)
    Step: function()
    {
        //clear arrows
        this.UpArrow = "";
        this.DownArrow = "";
        this.RightArrow = "";
        this.LeftArrow = "";
        //Current line is the line to execute
        let line = this.Memory[this.PC];
        //alert('Line: ' + line);
        //remove comments
        if(line.indexOf('#') >= 0)
        {
            line = line.substring(0,line.indexOf('#'));
        }
        //remove labels
        if(line.indexOf(':') >= 0)
        {
            line = line.substring(line.lastIndexOf(':')+1,line.length);
        }
        
        //now split by space
        let spline = line.split(" ");
        
        
        //remove empty elements from the array
        let i = spline.length -1; 
        for(i = spline.length -1; i >=0; i--)
            if(spline[i].length == 0)
                spline.splice(i,1); //remove 1 element starting at i
       
        
        //boolean for pc
        let incPC = true;
        
        //just to catch when you have an empty line
        if(typeof spline[0] === 'string') 
        {
            //alert('opcode: ' + spline[0]);
            
            //switch on opcode
            switch(spline[0])
            {
            case "NOP":
                break;
            case "SWP":
                 let temp = this.Acc;
                 this.Acc = this.Bak;
                 this.Bak = temp;
                break;
            case "SAV":
                this.Bak = this.Acc;
                break;
            case "ADD":
                this.Acc += this.GetValue(spline[1]);
                break;
            case "SUB":
                this.Acc -= this.GetValue(spline[1]);
                break;
            case "NEG":
                this.Acc = -1 * this.Acc;
                break;
            case "JMP":
                //alert('pc:' + this.PC);
                //alert('sym' + spline[1]);
                //alert('sympc' + this.SymbolTable[spline[1]]);
                this.PC = this.SymbolTable[spline[1]];
                incPC = false;
                break;
            case "JEZ":
                if(this.Acc == 0)
                {
                    this.PC = this.SymbolTable[spline[1]];
                    incPC = false;
                }
                break;
            case "JNZ":
                if(this.Acc != 0)
                {
                    this.PC = this.SymbolTable[spline[1]];
                    incPC = false;
                }
                break;
            case "JGZ":
                if(this.Acc > 0)
                {
                    this.PC = this.SymbolTable[spline[1]];
                    incPC = false;
                }
                break;
            case "JLZ":
                if(this.Acc < 0)
                {
                    this.PC = this.SymbolTable[spline[1]];
                    incPC = false;
                }
                break;
            case "JRO": //offset
                this.PC = this.PC + this.GetValue(spline[1]);
                incPC = false;
                break;
            case "MOV": //takes 2 cycles
                this.Cycles = this.Cycles + 1;
                let oper1 ='';
                let oper2 = '';
                //need to verify if comma exists if mov
                if(line.split(',').length == 2)
                {
                    if(spline.length == 2)
                    {
                        oper1 = spline[1].split(',')[0];
                        oper2 = spline[1].split(',')[1];
                    }
                    else if(spline.length == 3)
                    {
                        oper1 = spline[1].replace(',', '');
                        oper2 = spline[2].replace(',', '');
                    }
                }
                else
                {
                    //ERROR
                    //alert('ERROR 1');
                    this.ErrorFlag = true;
                    this.ErrorString = "BAD MOV FORMAT";
                    return false;
                }
                
                //get value to move
                //alert('operand1: ' + spline[1]);
                let val = this.GetValue(oper1);
                //alert('val'+val);
                
                
                //get location to move to
                //alert('operand2: ' + spline[2]);
                switch (oper2)
                {
                case "NIL":
                    break;
                case "ACC":
                    //alert('h');
                    this.Acc = val;
                    break;
                case "UP":
                    //check for error port 
                    if(this.ErrorPort.search('U')>=0)
                    {
                        this.ErrorFlag = true;
                        this.ErrorString = "WRITE TO  INVALID PORT UP";
                        return false;
                    }
                    this.Up = val;
                    this.IOAccess = this.IOAccess + 1;
                    this.UpArrow = "OUT";
                    break;
                case "DOWN":
                    //check for error port 
                    if(this.ErrorPort.search('D')>=0)
                    {
                        this.ErrorFlag = true;
                        this.ErrorString = "WRITE TO  INVALID PORT DOWN";
                        return false;
                    }
                    this.Down = val;
                    this.IOAccess = this.IOAccess + 1;
                    this.DownArrow = "OUT";
                    break;
                case "LEFT":
                    //check for error port 
                    if(this.ErrorPort.search('L')>=0)
                    {
                        this.ErrorFlag = true;
                        this.ErrorString = "WRITE TO INVALID PORT LEFT";
                        return false;
                    }
                    this.Left = val;
                    this.IOAccess = this.IOAccess + 1;
                    this.LeftArrow = "OUT";
                    break;
                case "RIGHT":
                    //check for error port 
                    if(this.ErrorPort.search('R')>=0)
                    {
                        this.ErrorFlag = true;
                        this.ErrorString = "WRITE TO INVALID PORT RIGHT";
                        return false;
                    }
                    this.Right = val;
                    this.IOAccess = this.IOAccess + 1;
                    this.RightArrow = "OUT";
                    break;
                default: //need to handle error
                    //alert('ERROR 2');
                    this.ErrorFlag = true;
                    this.ErrorString = "BAD MOV COMMAND";
                    return false;//"BAD MOV COMMAND";
                    break;
                };
                break;
            default: //need to handle error
                //alert('BAD OPCODE');
                this.ErrorFlag = true;
                this.ErrorString = "BAD OPCODE";
                return false;
                break;
            };
            
            if(this.PC == undefined || this.PC == null)
            {
                this.PC = 0;
                this.ErrorFlag = true;
                this.ErrorString = "BAD LABEL";
                return false;
            }
        }
        else
        {
           //Error for empty line or comment line
           // alert('ERROR 4');
           this.ErrorFlag = true;
           this.ErrorString = "Empty line";
           return false;
        }
        
        //increase cycles by 1
        this.Cycles = this.Cycles + 1;
        if(this.Cycles > this.MaxCycles)
            this.Running = false;
        
        //increment counter   
        if(incPC == true)
        {
            if(this.AutoLoop == true){
                this.PC = (this.PC + 1)%this.Memory.length;//16;
            }
            else
            {
                this.PC = (this.PC + 1);
                if(this.PC >= this.Memory.length)
                    this.Running = false;
            }
        }
        
        return true;
    },
    
    //just counts the instructions
    InstCount: function()
    {
        //I'm too lazy to count them right now, so I'm going to use the number of lines that aren't blank
        this.InstructionCount = this.Memory.length;
        var i=0;
        for(i=0 ; i<this.Memory.length; i++)
            if(this.Memory[i].replace(' ','').length == 0)
                this.InstructionCount--;
        return;
    },
    
    
    //************************************************************
    //unused functions
    //helper functions to set ports (not used)
    PortsIn: function(u,r,d,l)
    {
        if(u != null)
            this.Up = parseInt(u);
        if(r != null)
            this.Right = parseInt(r);
        if(d != null)
            this.Down = parseInt(d);
        if(l != null)
            this.Left = parseInt(l);
        return;
    },
    PortUIn: function(u)
    {
        //check for error port 
        if(this.ErrorPort.search('U')>=0)
        {
            this.ErrorFlag = true;
            this.ErrorString = "ACCESSED INVALID PORT UP";
            return 0;
        }
        this.Up = parseInt(u);
        return;
    },
    PortRIn: function(r)
    {
        //check for error port 
        if(this.ErrorPort.search('R')>=0)
        {
            this.ErrorFlag = true;
            this.ErrorString = "ACCESSED INVALID PORT RIGHT";
            return 0;
        }
        this.Right = parseInt(r);
        return;
    },
    PortDIn: function(d)
    {
        //check for error port 
        if(this.ErrorPort.search('D')>=0)
        {
            this.ErrorFlag = true;
            this.ErrorString = "ACCESSED INVALID PORT DOWN";
            return 0;
        }
        this.Down = parseInt(d);
        return;
    },
    PortLIn: function(l)
    {
        //check for error port 
        if(this.ErrorPort.search('L')>=0)
        {
            this.ErrorFlag = true;
            this.ErrorString = "ACCESSED INVALID PORT LEFT";
            return 0;
        }
        this.Left = parseInt(l);
        return;
    },
    
    //to run the machine - not implemented
    Run: function(testarrays)
    {
        //maybe we don't define this and we just assume a loop from the app
        return;
    }
    
};
